import { render, staticRenderFns } from "./AirQualityHistoricalDataItem.vue?vue&type=template&id=17a45b64"
import script from "./AirQualityHistoricalDataItem.vue?vue&type=script&lang=js"
export * from "./AirQualityHistoricalDataItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports